var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9003 0H8.0997C3.62636 0 0 3.62636 0 8.0997V26.9003C0 31.3736 3.62636 35 8.0997 35H26.9003C31.3736 35 35 31.3736 35 26.9003V8.0997C35 3.62636 31.3736 0 26.9003 0Z",
    fill: "url(#paint0_linear_304_337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.8121C12.712 5.8121 8.16549 5.3865 6.42879 9.8434C5.71129 11.6844 5.81559 14.0749 5.81559 17.4979C5.81559 20.5016 5.71899 23.3254 6.42879 25.1517C8.16129 29.6114 12.7449 29.1844 17.4979 29.1844C22.2509 29.1844 26.81 29.6618 28.5684 25.1517C29.2873 23.2925 29.1816 20.937 29.1816 17.4979C29.1816 12.9325 29.4336 9.9855 27.2195 7.7728C24.9781 5.5314 21.9464 5.8121 17.4958 5.8121H17.5014H17.5ZM16.4528 7.9177C26.4404 7.9016 27.7116 6.7914 27.0102 22.2159C26.761 27.671 22.6072 27.0725 17.5014 27.0725C8.19139 27.0725 7.92399 26.8058 7.92399 17.4923C7.92399 8.1788 8.66249 7.9226 16.4528 7.9149V7.9177ZM23.737 9.8574C22.9628 9.8574 22.3356 10.4853 22.3356 11.2588C22.3356 12.0323 22.9635 12.6602 23.737 12.6602C24.5105 12.6602 25.1384 12.0323 25.1384 11.2588C25.1384 10.4853 24.5105 9.8574 23.737 9.8574ZM17.5 11.4968C14.1862 11.4968 11.5003 14.1841 11.5003 17.4979C11.5003 20.8117 14.1862 23.4976 17.5 23.4976C20.8138 23.4976 23.4983 20.8117 23.4983 17.4979C23.4983 14.1841 20.8138 11.4968 17.5 11.4968ZM17.5 13.6024C22.6492 13.6024 22.6562 21.3927 17.5 21.3927C12.3438 21.3927 12.3438 13.6024 17.5 13.6024Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_337",
    x1: 1.4007,
    y1: 33.2675,
    x2: 32.9413,
    y2: 2.3772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/IG.8fdb436a5edf589cd242c31f337c4c45.svg";
export { ForwardRef as ReactComponent };